import React, { useState, useEffect, useContext, useMemo } from 'react';
import {
  uploadFile,
  sanctionIoHits,
  createNotification,
  createKycComment,
  getkycRiskAssessment,
  sendEmailNotification,
  getkyc,
  updatekycStatus,
  createkycRiskAssessment,
  updatekycRiskAssessment,
  getAllUsers,
  frontEndBaseURL,
  createKycRecord,
  getKycRecord,
  amlWatcherHits,
  getkycRiskAssessmentById,
} from '../../../../API/Api';
import { Card, checkAPICallsQuota } from '../../../shared/utils';
import KycQuotaModal from '../../../shared/KycQuotaModal';
import Loading from '../../../shared/Loading';
import { DateTime } from 'luxon';
import { toast } from 'react-toastify';
import { v4 as uuidv4 } from 'uuid';
import { ListB, ListC, ListD, highRiskJurisdictions, transparencyInternational } from '../../../../data/RiskCountries';
import SanctionsScreeningSectionLaw from './SanctionsScreeningSection_Law';
import SubmissionCard from '../components/SubmissionCard';
import SubmissionCardVideoLaw from '../SubmissionCard_Video_Law.js';

import { jwtDecode } from 'jwt-decode';
import { TokenContext } from '../../../../App';

import { RiskLevel } from '../enums';
import CustomTooltip from '../CustomTooltip';

const _RiskAssessment = ({ clientFormId, userType, readOnly, currentUrl, formAuthority }) => {
  const [encodedAccessToken] = useContext(TokenContext);
  // 使用 useMemo 缓存 decodedToken，避免每次渲染都创建新对象
  const decodedToken = useMemo(() => jwtDecode(encodedAccessToken), [encodedAccessToken]);
  console.log('进入riskAssessment_LAW_AML');

  const [formData, setFormData] = useState({
    kycaml_client_id: clientFormId,
    formAuthority: formAuthority,
    screenedDate: '',
    submittedBy: '',
    reviewerReviewEmail: [],
    sourceOfWealthDocumentURL: '',
    otherDocumentsURL: '',
    managementSupportDocumentURL: '',
    screenedDate: '',
    nextRescreeningDate: '',
    status: 'new',
    hasFilledEdd: false,
    riskLevel: '', //work around to show default value, to fix
    riskReasons: '',
    // riskLevel: 'Incomplete questions!', screenedDate: '', nextRescreeningDate: '', status: 'new', //   // status: 'yet to be decided by reviewer, aka pending_admin_review',

    singaporeGovernmentEntity: '',
    listedOnStockExchange: '',
    singaporeFI: '',
    nonSingaporeFI: '',
    politicallyExposedPerson: '',
    countryCountermeasureFATF: '',
    countryInadequateAML_CFT: '',
    higherRiskSector: '',
    highRiskJurisdictionFATF: '',
    credibleBodyIdentifiedCountry: '',

    investmentVehicle: { response: '', justification: '', newComment: '', comments: [] }, // comment object [ {name: '', content: '', time: '', id: ''} ]
    customerPensionSuperannuation: { response: '', justification: '', newComment: '', comments: [] },
    unverifiedBusinessActivity: { response: '', justification: '', newComment: '', comments: [] },
    unverifiedCorporateStructure: { response: '', justification: '', newComment: '', comments: [] },
    unverifiedFinancialActivity: { response: '', justification: '', newComment: '', comments: [] },
    unusualOwnershipStructure: { response: '', justification: '', newComment: '', comments: [] },
    unusualBusinessCircumstances: { response: '', justification: '', newComment: '', comments: [] },
    nomineeShareholdersBearer: { response: '', justification: '', newComment: '', comments: [] },
    anonymousTranscations: { response: '', justification: '', newComment: '', comments: [] },
    unknownPaymentSources: { response: '', justification: '', newComment: '', comments: [] },

    pepHits: [],
    //   nameTitle: '', positionStart: 'NA', positionEnd: 'NA',  si_identifier: '',
    //   answer: '', justification: '', comments:[], newComment // just reference it, save as empty string if needed.
    crimesHits: [],
    // nameDataSource: '', remarks: '',  // name: '', dataSource: '', remarks: '',
    // answer: '', justification: '', comments:[] // comment object [ {name: '', content: '', time: '', id: ''} ]
    sanctionsHits: [],
    // name: '', dataSource: '',
    // answer: '', justification: '', comments:[]
    highRiskJurisdictionHits: [],
    // name: '', dataSource: '',
    // answer: '', justification: '', comments:[]
    adverseNewsHits: [],
    // title: '', description: '', url: '',
    // answer: '', justification: '', comments:[]
    screeningSource: 'sanctions.io',
    sourceOfWealthDocumentURL: '',
    managementSupportDocumentURL: '',
    otherDocumentsURL: '',
    enhancedOngoingMonitoringRelationship: '',
    questionApiUrl: {},
  });
  const [kycData, setKycData] = useState();
  const [loading, setLoading] = useState(true);
  const [crimesHitsLoading, setCrimesHitsLoading] = useState(false);
  const [allreviewers, setAllreviewers] = useState([]);
  const userRole = decodedToken.role;
  const [mandatoryFieldError, setMandatoryFieldError] = useState({
    riskLevel: '',
  });
  const [records, setRecords] = useState([]);
  const [editable, setEditable] = useState(true);
  const isApprovalAccepted = formData?.status === 'accepted';
  const effectiveReadOnly = readOnly || isApprovalAccepted;
  const [showQuotaModal, setShowQuotaModal] = useState(false);
  const [loadingMessage, setLoadingMessage] = useState('Assessment loading...');
  const [apiFailed, setApiFailed] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      try {
        let allreviewers = (await getAllUsers()).data;
        allreviewers = allreviewers.filter(users => users.role !== 'preparer' && users.role !== 'viewer');
        setAllreviewers(allreviewers);

        const currentKycData = await getkyc(clientFormId).then(response => response.data);
        setKycData(currentKycData);

        // const currentKycData = await getkycRiskAssessment(clientFormId).then(response => response.data);
        // let kycRiskData = kycRiskDataList[0] // verify if this indeed returns the oldest one? // so far seems ok.
        // let kycRiskData = kycRiskDataList.at(-1)
        let kycRiskDataList = await getkycRiskAssessment(clientFormId).then(response => response.data);
        if (currentKycData.maxPage > 2) {
          console.log('kycRiskDataList', kycRiskDataList);
          kycRiskDataList = kycRiskDataList.filter(item => item.status == 'accepted');
        }
        let kycRiskData = kycRiskDataList[0];
        // TODO
        getKycRecordData(currentKycData['_id']);
        if (!kycRiskDataList.length == 0) {
          const status = kycRiskData?.status;
          setEditable(!readOnly && status !== 'accepted');
          setFormData(kycRiskData);
          setLoading(false);
          // 检查所有 hits 是否都为空
          const allHitsEmpty =
            (!kycRiskData.pepHits || kycRiskData.pepHits.length === 0) &&
            (!kycRiskData.crimesHits || kycRiskData.crimesHits.length === 0) &&
            (!kycRiskData.sanctionsHits || kycRiskData.sanctionsHits.length === 0) &&
            (!kycRiskData.highRiskJurisdictionHits || kycRiskData.highRiskJurisdictionHits.length === 0) &&
            (!kycRiskData.adverseNewsHits || kycRiskData.adverseNewsHits.length === 0);

          if (
            (!kycRiskData.searchReference || kycRiskData.searchReference.length == 0) &&
            allHitsEmpty &&
            currentKycData.maxPage < 3
          ) {
            toast.warning('Data retrieval failed — source may be temporarily unavailable. Please retry later');
            setApiFailed(true);
            setLoading(false);
          }
          return;
        }

        setEditable(!readOnly);
        toast.info(`Assessment running...`);
        // 1. Run automated checks and create entry
        const emptyFormData = automatedChecks(clientFormId, currentKycData);
        const creationDate = DateTime.now().setZone('Asia/Singapore').toFormat('dd-MM-yyyy, HH:mm:ss');
        kycRiskData = {
          ...emptyFormData,
          screenedDate: creationDate,
          createDate: creationDate,
        };

        let riskAssessmentId = '';
        const res = await createkycRiskAssessment(kycRiskData);
        if (res && res.status === 200 && res.data.status) {
          if (!res.data.success) {
            toast.error('Failed to create assessment!');
            setLoading(false);
            return;
          }
          riskAssessmentId = res.data.risk_id;
          kycRiskData = { ...kycRiskData, _id: riskAssessmentId };
        } else {
          toast.error('Failed to create assessment!');
          setLoading(false);
          return;
        }

        //检验api调用次数
        const quotaExceeded = await checkAPICallsQuota(setShowQuotaModal);
        if (quotaExceeded) {
          setLoading(false);
          return;
        }
        // 2. Call sanctions.io API and update entry

        const payload = {
          // apiKey, apiSecret,
          screenedName: currentKycData['name'],
          connectedParty: currentKycData?.details?.connectedParty,
          entityType: currentKycData['type'],
          kycaml_client_id: currentKycData['_id'],
          screenedDate: creationDate,
          screeningSource: 'amlWatcher',
          nationality: currentKycData?.details?.nationality,
          riskAssessmentId: riskAssessmentId,
        };
        const startTime = new Date();
        const amlWatcherResponse = await amlWatcherHits(payload);

        if (!amlWatcherResponse.data.success) {
          toast.warning('Data retrieval failed — source may be temporarily unavailable. Please retry later');
          setApiFailed(true);
          setLoading(false);
          return;
        }

        const {
          pepHits,
          crimesHits,
          sanctionsHits,
          highRiskJurisdictionHits,
          adverseNewsHits,
          questionApiUrl,
          riskLevel,
          isCreatedSearch,
        } = amlWatcherResponse.data;
        // 使用函数式更新，避免依赖 formData 的闭包问题
        setFormData(prevFormData => ({
          ...prevFormData,
          pepHits,
          crimesHits,
          sanctionsHits,
          highRiskJurisdictionHits,
          adverseNewsHits,
          screeningSource: 'amlWatcher',
          _id: riskAssessmentId,
          questionApiUrl,
          riskLevel,
        }));
        setApiFailed(false);
        setLoading(false);
        // if(isCreatedSearch){
        //   await pollForCrimesHits(riskAssessmentId, startTime,isCreatedSearch);
        // }
        toast.success(`Assessment complete!`);
      } catch (e) {
        console.error(e);
        toast.error(`Something went wrong...`);
      }
    };

    fetchData();
  }, [clientFormId, currentUrl]);

  useEffect(() => {
    if (formData?.status === 'accepted') {
      setEditable(false);
    }
  }, [formData?.status]);

  const handleInputChange = e => {
    const { name, value } = e.target;
    const newFormData = {
      // instead of setState, prevData => {...prevData, new: newValue}
      ...formData, // do this, to ensure is kept up to date
      [name]: value,
    };
    setFormData(newFormData);
  };

  const handleRunAssessmentAgain = async e => {
    try {
      //检验api调用次数
      const quotaExceeded = await checkAPICallsQuota(setShowQuotaModal);
      if (quotaExceeded) return;
      setLoading(true);
      toast.info(`Assessment running...`);

      const currentKycData = await getkyc(clientFormId).then(response => response.data);
      setKycData(currentKycData);

      // 1. Run automated checks and create entry
      const emptyFormData = automatedChecks(clientFormId, currentKycData);
      const creationDate = DateTime.now().setZone('Asia/Singapore').toFormat('dd-MM-yyyy, HH:mm:ss');
      let riskAssessmentId = formData._id;
      const kycRiskData = {
        ...emptyFormData,
        screenedDate: creationDate,
        _id: riskAssessmentId,
        createDate: formData.createDate || creationDate,
      };

      const res = await updatekycRiskAssessment(kycRiskData);
      if (res && res.status === 200 && res.data.status) {
        if (!res.data.success) {
          toast.error('Failed to update assessment!');
          setLoading(false);
          return;
        }
      } else {
        toast.error('Failed to update assessment!');
        setLoading(false);
        return;
      }
      // 2. Call sanctions.io API and update entry
      const payload = {
        // apiKey, apiSecret,
        screenedName: currentKycData['name'],
        connectedParty: currentKycData?.details?.connectedParty,
        entityType: currentKycData['type'],
        kycaml_client_id: currentKycData['_id'],
        screenedDate: creationDate,
        screeningSource: 'amlWatcher',
        nationality: currentKycData?.details?.nationality,
        riskAssessmentId: riskAssessmentId,
      };
      const startTime = new Date();
      const amlWatcherHitsResponse = await amlWatcherHits(payload);

      if (!amlWatcherHitsResponse.data.success) {
        toast.error(amlWatcherHitsResponse.data.message);
        setApiFailed(true);
        setLoading(false);
        return;
      }

      const {
        pepHits,
        crimesHits,
        sanctionsHits,
        highRiskJurisdictionHits,
        adverseNewsHits,
        questionApiUrl,
        riskLevel,
        isCreatedSearch,
      } = amlWatcherHitsResponse.data;
      // 使用函数式更新，避免依赖 formData 的闭包问题
      setFormData(prevFormData => ({
        ...prevFormData,
        pepHits,
        crimesHits,
        sanctionsHits,
        highRiskJurisdictionHits,
        adverseNewsHits,
        screeningSource: 'amlWatcher',
        questionApiUrl,
        riskLevel,
        createDate: formData.createDate || creationDate,
      }));

      setApiFailed(false);
      setLoading(false);
      // if(isCreatedSearch){
      //   await pollForCrimesHits(riskAssessmentId, startTime,isCreatedSearch);
      // }
      toast.success(`Assessment complete!`);
    } catch (e) {
      console.error(e);
      setLoading(false);
      toast.error(`Something went wrong...`);
    }
  };

  const getKycRecordData = async kycaml_client_id => {
    let items = await getKycRecord(kycaml_client_id);
    setRecords(items?.data);
  };

  const handleRecordChange = async e => {
    const _id = e.target.value;
    const currentRecord = records?.filter(record => {
      return record._id == _id;
    })[0];
    if (currentRecord) {
      const currentRiskReasons = currentRecord?.riskReasons || '';
      setEditable(
        _id == records[0]?._id &&
          (formData.status == 'new' || formData.status == 'waiting for review' || formData.status == 'rejected') &&
          formData.status !== 'accepted'
      );
      const newFormData = {
        ...formData,
        riskReasons: currentRiskReasons,
      };
      setFormData(newFormData);
    } else {
      setEditable(false);
    }
  };

  const handleSaveForm = async e => {
    const res = await updatekycRiskAssessment(formData);
    if (res && res.status === 200 && res.data.status) {
      if (res.data.success) {
        toast.success('Assessment saved!');
      } else {
        toast.warning('Assessment already saved!');
      }
    } else {
      toast.error('Failed to save assessment!');
    }
  };

  // const checkFormValidity = () => {
  //   const isValid = Object.values(formData).every(value => value.trim() !== '');

  //   if ()
  //   setIsFormValid(isValid);
  // };

  const hasFilledEdd = () => {
    if (
      formData.sourceOfWealthDocumentURL &&
      formData.managementSupportDocumentURL &&
      formData.otherDocumentsURL &&
      formData.enhancedOngoingMonitoringRelationship?.trim() !== ''
    )
      return true;
    return false;
  };

  const handleSubmitForReview = async e => {
    const requiredFields = ['riskLevel'];
    let allRequiredFieldsFilled = true;
    let newMandatoryFieldError = { ...mandatoryFieldError };

    requiredFields.forEach(field => {
      if (!formData[field]) {
        allRequiredFieldsFilled = false;
        newMandatoryFieldError[field] = true;
      } else {
        newMandatoryFieldError[field] = false;
      }
    });
    setMandatoryFieldError(newMandatoryFieldError);

    if (!allRequiredFieldsFilled) {
      toast.warning('Please fill in the required fields');
      return;
    }

    let newFormData = {
      ...formData,
      hasFilledEdd: hasFilledEdd(),
      status: 'waiting for review',
      submitPerson: decodedToken.name,
      submitDate: DateTime.now().setZone('Asia/Singapore').toFormat('dd-MM-yyyy, HH:mm:ss'),
    };

    // submittedBy
    const res = await updatekycRiskAssessment(newFormData);
    if (res && res.status === 200 && res.data.status) {
      await updatekycStatus({ formStatus: 'pending_reviewer_review', id: clientFormId });
      toast.success(`Submitted for review!`);
    } else {
      toast.error(`Submitted for review failed!`);
      return;
    }

    sendEmailNotification({
      email: formData.reviewerReviewEmail?.includes('/')
        ? formData.reviewerReviewEmail.split('/')[0]
        : formData.reviewerReviewEmail,
      subject: 'KYC Risk Assessment Form pending review - iCompass',
      message: `
        <div style="max-width: 600px; margin: 0 auto; border: 2px solid #FF8C00; padding: 20px; text-align: center;">
          <h1 style="margin-bottom: 20px; text-decoration: underline;"> Risk Assessment Approval Pending</h1>
          <p>${decodedToken.name} has submitted a risk assessment form, ${kycData.name} (${kycData.type}), for your approval.
            <a href='${window.location.href}'> Click to view form </a>
          </p>
          <img src="https://icompass-backend-dev-fhagh5hccpf2ebh9.southeastasia-01.azurewebsites.net/images/from_icompass" alt="iCOMPASS logo" style="display: block; margin: 20px auto; width: 200px; height: auto; max-width: 100%;">
          <p style="font-style: italic; margin-top: 20px;">Please do not reply to this email</p>
        </div> `,
    });

    setFormData(newFormData);

    createNotification({
      type: 'KYC',
      text: `${kycData.name} status has changed to Pending reviewer Review`,
      date: DateTime.now().toFormat('dd-MM-yyyy HH:mm:ss'),
    });

    // TODO
    await getKycRecordData(clientFormId);
  };

  const handleFileChange = async (e, fileType) => {
    const file = e.target.files[0];
    const { name } = e.target;
    if (!file) {
      return;
    }

    try {
      const data = new FormData();
      data.append('file', file);
      const filename = `${file.name}`;
      const res = await uploadFile(data, filename);

      if (res) {
        setFormData(prevState => ({
          ...prevState,
          [name]: res.data.url,
          // identificationDocumentLink :  res.data.url // name refer to 'input name' property.
        }));
      } else {
        toast.error('Invalid file type!');
      }
    } catch (e) {
      toast.error(`Invalid file type!`);
    }
  };

  const getRiskTag = risk => {
    const riskClasses = {
      Low: 'text-green-500',
      Standard: 'text-orange-500',
      High: 'text-red-500',
      Edge: 'text-purple-600',
    };
    const riskClass = riskClasses[risk] || riskClasses['Edge']; // Default to 'Edge' for incomplete question
    return <span className={`bg-gray-200 py-2 px-4 border border-b-gray-300 ${riskClass}`}>{risk}</span>;
  };

  const getStatusTag = status => {
    if (status == 'new' || status == 'waiting for review') {
      return <span className='text-orange-500'> Yet to be decided by reviewer</span>;
    } else if (status == 'accepted') {
      return <span className='text-green-500'>Accepted</span>;
    } else if (status == 'rejected') {
      return <span className='text-red-500'>Rejected</span>;
    } else {
      return <span className='text-purple-600'>Edge case!!!</span>;
    }
  };

  const handleStatusUpdate = async (e, updatedStatus) => {
    // if (!allQuestionsAnswered) {
    //   toast.error('Please answer all questions!')
    //   return  accepted  rejected
    //  }
    //检验api调用次数
    // 开启loading
    setLoadingMessage('Loading...');
    setLoading(true);
    const quotaExceeded = await checkAPICallsQuota(setShowQuotaModal);
    if (quotaExceeded) {
      toast.error('You have reached your API call limit. Please upgrade your plan.');
      setLoading(false);
      return;
    }

    let nextRescreeningDate = '';
    let onGoingMonitoring = '';
    let currentDate = DateTime.now().setZone('Asia/Singapore');
    let maxPage = 2;
    if (kycData?.details?.isvVideo === 'yes') {
      maxPage = 3;
    } else {
      maxPage = 2;
    }

    if (updatedStatus == 'accepted') {
      if (formData.riskLevel == 'Low') {
        nextRescreeningDate = currentDate.plus({ years: 2 }).toFormat('dd-MM-yyyy');
      }
      if (formData.riskLevel == 'High') {
        nextRescreeningDate = currentDate.plus({ years: 1 }).toFormat('dd-MM-yyyy');
      }
      if (decodedToken.companyId == 'Inspro_Insurance') {
        nextRescreeningDate = currentDate.plus({ years: 1 }).toFormat('dd-MM-yyyy');
      }
      if (decodedToken.companyId == 'folich-llc-law') {
        if (formData.riskLevel == 'Low') {
          nextRescreeningDate = currentDate.plus({ years: 2 }).toFormat('dd-MM-yyyy');
        }
        if (formData.riskLevel == 'High') {
          nextRescreeningDate = currentDate.plus({ days: 90 }).toFormat('dd-MM-yyyy');
        }
      }
      onGoingMonitoring = true;
      if (kycData?.details?.isvVideo === 'yes') {
        maxPage = 4;
      } else {
        maxPage = 3;
      }
      formData.reviewStatus = 'Pending Assessment';
    }
    // console.log("创建客户的创建时间："+formData.status)
    // if(formData&&formData.status==='new'){

    formData.updateDate = DateTime.now().setZone('Asia/Singapore').toFormat('dd-MM-yyyy, HH:mm:ss');
    // }
    // console.log(formData)
    const newFormData = {
      ...formData,
      status: updatedStatus,
      screenedDate: DateTime.now().setZone('Asia/Singapore').toFormat('dd-MM-yyyy, HH:mm:ss'),
      nextRescreeningDate: nextRescreeningDate,
      approvalPerson: decodedToken.name,
      approvalDate: DateTime.now().setZone('Asia/Singapore').toFormat('dd-MM-yyyy, HH:mm:ss'),
    };

    setFormData(newFormData);

    updatekycStatus({
      reviewStatus: 'Pending Assessment',
      formStatus: updatedStatus,
      id: clientFormId,
      nextRescreeningDate: nextRescreeningDate,
      onGoingMonitoring: onGoingMonitoring,
      maxPage: maxPage,
      updateDate: DateTime.now().setZone('Asia/Singapore').toFormat('dd-MM-yyyy, HH:mm:ss'),
    });

    const res = await updatekycRiskAssessment(newFormData);
    if (res.data.success) {
      createNotification({
        type: 'KYC',
        text: `${kycData.name} status has changed to ${updatedStatus}`,
        date: DateTime.now().toFormat('dd-MM-yyyy HH:mm:ss'),
      });
      toast.success('Assessment updated successfully');
      setLoading(false);
    } else {
      toast.error('Failed to update assessment');
      setLoading(false);
    }
    // TODO 后台已经实现了
    // createKycRecord({
    //   kycaml_client_id: newFormData.kycaml_client_id,
    //   submitPerson: newFormData.submitPerson,
    //   riskLevel: newFormData.riskLevel,
    //   riskReasons: newFormData.riskReasons,
    //   submitDate: newFormData.submitDate,
    // });
  };

  let qnCounter = 1;
  const requireHigherRiskLevelPrompt = formData.riskLevel === RiskLevel.HIGH;

  return (
    <div className={`max-w-6xl mx-auto mt-3 p-5 rounded-lg shadow-lg ${effectiveReadOnly ? 'bg-gray-200' : 'bg-white '}`}>
      {loading && <Loading message={loadingMessage} />}
      <div>
        <div className='flex justify-between'>
          <h1 className='font-semibold underline text-2xl m-2 mb-4'>KYC Form - Risk Assessment </h1>
          {/* <h1 className='font-semibold underline text-2xl m-2 mb-4'>KYC Form - Risk Assessment (MAS) </h1> -> ADHOC TEMP REMOVAL OF MAS DISPLAY (.formAuthority), TO UNCOMMENT AND REMOVE THE ABOVE LINE */}
          <button
            onClick={handleRunAssessmentAgain}
            disabled={effectiveReadOnly}
            className={`self-center w-2/12 py-1 px-2 bg-green-500 hover:bg-green-600 text-white font-semibold rounded-lg ${effectiveReadOnly ? 'opacity-30' : 'opacity-100'}`}
          >
            Run Assessment again
          </button>
        </div>

        {/* EDD qn13-17 */}
        <SanctionsScreeningSectionLaw
          userId={clientFormId}
          decodedToken={decodedToken}
          qnCounter={qnCounter}
          readOnly={effectiveReadOnly}
          formData={formData}
          kycData={kycData}
          setFormData={setFormData}
          crimesHitsLoading={crimesHitsLoading}
          apiFailed={apiFailed}
        />

        <Card>
          <p className='mb-2 font-semibold'> Outcome </p> <hr />
          <p className='my-4'>
            {' '}
            <span>
              The risk level assessed upon initial screening is: <i className='text-red-600'>*</i>
            </span>
            <select
              name='riskLevel'
              value={formData.riskLevel}
              onChange={handleInputChange}
              disabled={effectiveReadOnly}
              className='ml-2 p-1 border border-gray-300 rounded'
            >
              <option value=''>- Please select- </option>
              <option value={RiskLevel.LOW}>{RiskLevel.LOW}</option>
              <option value={RiskLevel.HIGH}>{RiskLevel.HIGH}</option>
            </select>
          </p>
          <div>
            <p className='flex'>
              <span className='w-5/24 mr-2 mt-1'>
                {' '}
                Justification for risk level: <i className='text-red-600'>*</i>
              </span>
              <a
                href='https://law-society-singapore-prod.s3.ap-southeast-1.amazonaws.com/2025/10/PD-3.2.1-Prevention-of-ML-FT-and-PF-061025LSS-FinalF1061025clean.pdf'
                target='_blank'
                rel='noopener noreferrer'
              >
                <CustomTooltip title='Refer to Practice Direction PD 3.2.1 – Annex B4 (page 54) for ML/FT high risk factors, Annex B5 (page 57) for PF high risk factors and Annex F (page 67) for Ministry of Law’s Guidance.' />
              </a>
              <select
                name='selectedRecord'
                className='w-5/12 p-1.5 mb-5 border-b-2 border-b-gray-300 bg-gray-100 focus:outline-none  mr-6 focus:border-green-500'
                onChange={handleRecordChange}
                style={{ marginLeft: 'auto' }}
              >
                <option disabled> - History - </option>
                {records?.map(record => (
                  <option value={record['_id']}>
                    {' '}
                    {record.submitDate} ({record.submitPerson}, {record.riskLevel}){' '}
                  </option>
                ))}
              </select>
            </p>
            <textarea
              maxLength={800}
              disabled={!editable}
              placeholder='Please enter the reason'
              onChange={handleInputChange}
              name='riskReasons'
              value={formData.riskReasons}
              className='w-full mt-1 p-1.5 border-b-2 border-b-gray-300 bg-gray-100 focus:outline-none focus:border-green-500'
              rows={3}
            />
            {mandatoryFieldError.riskReasons && (
              <p style={{ color: 'red' }}>Please provide justification for risk level</p>
            )}
          </div>
          {kycData?.details?.isvVideo === 'yes' && (
            <SubmissionCardVideoLaw
              getRiskTag={getRiskTag}
              formData={formData}
              setFormData={setFormData}
              handleFileChange={handleFileChange}
              getStatusTag={getStatusTag}
              handleStatusUpdate={handleStatusUpdate}
              handleSaveForm={handleSaveForm}
              handleInputChange={handleInputChange}
              currentUrl={currentUrl}
              userRole={userRole}
              allreviewers={allreviewers}
              handleSubmitForReview={handleSubmitForReview}
              clientFormId={clientFormId}
              readOnly={effectiveReadOnly}
              requireHigherRiskLevelPrompt={requireHigherRiskLevelPrompt}
              apiFailed={apiFailed}
            />
          )}
          {kycData?.details?.isvVideo !== 'yes' && (
            <SubmissionCard
              getRiskTag={getRiskTag}
              formData={formData}
              setFormData={setFormData}
              handleFileChange={handleFileChange}
              getStatusTag={getStatusTag}
              handleStatusUpdate={handleStatusUpdate}
              handleSaveForm={handleSaveForm}
              handleInputChange={handleInputChange}
              currentUrl={currentUrl}
              userRole={userRole}
              allreviewers={allreviewers}
              handleSubmitForReview={handleSubmitForReview}
              clientFormId={clientFormId}
              readOnly={effectiveReadOnly}
              requireHigherRiskLevelPrompt={requireHigherRiskLevelPrompt}
              apiFailed={apiFailed}
            />
          )}
        </Card>
      </div>
      <KycQuotaModal
        status={showQuotaModal}
        onClose={() => setShowQuotaModal(false)}
      />
    </div>
  );
};

export default _RiskAssessment;

function automatedChecks(clientFormId, currentKycData) {
  let emptyFormData = {
    kycaml_client_id: clientFormId,
    screenedDate: '',
    sourceOfWealthDocumentURL: '',
    otherDocumentsURL: '',
    riskLevel: '',
    riskReasons: '',
    nextRescreeningDate: '',
    // let emptyFormData = ({ kycaml_client_id: clientFormId, screenedDate: '', sourceOfWealthDocumentURL: '', otherDocumentsURL: '', riskLevel: 'Incomplete questions!', nextRescreeningDate: '',
    status: 'new',
    singaporeGovernmentEntity: 'No',
    listedOnStockExchange: 'No',
    singaporeFI: 'No',
    nonSingaporeFI: '',
    politicallyExposedPerson: '',
    countryCountermeasureFATF: '',
    countryInadequateAML_CFT: '',
    higherRiskSector: '',
    highRiskJurisdictionFATF: '',
    credibleBodyIdentifiedCountry: '',
    investmentVehicle: { response: '', justification: '', newComment: '', comments: [] },
    customerPensionSuperannuation: { response: '', justification: '', newComment: '', comments: [] },
    unverifiedBusinessActivity: { response: '', justification: '', newComment: '', comments: [] },
    unverifiedCorporateStructure: { response: '', justification: '', newComment: '', comments: [] },
    unverifiedFinancialActivity: { response: '', justification: '', newComment: '', comments: [] },
    unusualOwnershipStructure: { response: '', justification: '', newComment: '', comments: [] },
    unusualBusinessCircumstances: { response: '', justification: '', newComment: '', comments: [] },
    nomineeShareholdersBearer: { response: '', justification: '', newComment: '', comments: [] },
    anonymousTranscations: { response: '', justification: '', newComment: '', comments: [] },
    unknownPaymentSources: { response: '', justification: '', newComment: '', comments: [] },
    pepHits: [],
    crimesHits: [],
    sanctionsHits: [],
    highRiskJurisdictionHits: [],
    adverseNewsHits: [],
    screeningSource: 'amlWatcher',
  };

  if (currentKycData.type == 'individual') {
    // qn1-4
    emptyFormData.singaporeGovernmentEntity = 'No';
    emptyFormData.listedOnStockExchange = 'No';
    emptyFormData.singaporeFI = 'No';
    emptyFormData.nonSingaporeFI = 'No'; // check ListD for entity

    // qn7-9

    if (
      currentKycData?.details?.pepAssociate == 'yes' ||
      currentKycData?.details?.pepPerson == 'yes' ||
      currentKycData?.details?.pepFamily == 'yes'
    ) {
      emptyFormData.politicallyExposedPerson = 'Yes';
    } else {
      emptyFormData.politicallyExposedPerson = 'No';
    }

    if (ListB.includes(currentKycData?.details?.nationality)) {
      //check List B
      emptyFormData.countryCountermeasureFATF = 'Yes';
    } else {
      emptyFormData.countryCountermeasureFATF = 'No';
    }

    if (ListC.includes(currentKycData?.details?.nationality)) {
      // Check List C
      emptyFormData.countryInadequateAML_CFT = 'Yes';
    } else {
      emptyFormData.countryInadequateAML_CFT = 'No';
    }

    // qn 18
    emptyFormData.higherRiskSector = 'No';

    // qn 22, 23
    if (highRiskJurisdictions.includes(currentKycData?.details?.nationality)) {
      emptyFormData.highRiskJurisdictionFATF = 'Yes';
    } else {
      emptyFormData.highRiskJurisdictionFATF = 'No';
    }

    if (transparencyInternational.includes(currentKycData?.details?.nationality)) {
      emptyFormData.credibleBodyIdentifiedCountry = 'Yes';
    } else {
      emptyFormData.credibleBodyIdentifiedCountry = 'No';
    }

    return emptyFormData;
  } else if (currentKycData?.type == 'entity') {
    // qn1-4
    if (currentKycData?.details?.singaporeGovernmentEntity == 'yes') {
      emptyFormData.singaporeGovernmentEntity = 'Yes';
    } else {
      emptyFormData.singaporeGovernmentEntity = 'No';
    }

    if (currentKycData?.details?.listedOnStockExchange == 'yes') {
      emptyFormData.listedOnStockExchange = 'Yes';
    } else {
      emptyFormData.listedOnStockExchange = 'No';
    }

    if (
      currentKycData?.details?.financialInstitution == 'yes' &&
      currentKycData?.details?.incorporationCountry == 'SG'
    ) {
      emptyFormData.singaporeFI = 'Yes';
    } else {
      emptyFormData.singaporeFI = 'No';
    }

    if (
      currentKycData?.details?.financialInstitution == 'yes' &&
      ListD.includes(currentKycData?.details?.incorporationCountry)
    ) {
      //check List D
      emptyFormData.nonSingaporeFI = 'Yes';
    } else {
      emptyFormData.nonSingaporeFI = 'No';
    }

    // qn7
    emptyFormData.politicallyExposedPerson = 'No';
    currentKycData?.details?.connectedParty.forEach(party => {
      // .map produces a new array .forEach modify in place
      if (party?.pepAssociate == 'yes' || party?.pepPerson == 'yes' || party?.pepFamily == 'yes') {
        emptyFormData.politicallyExposedPerson = 'Yes';
      }
    });

    // qn8
    emptyFormData.countryCountermeasureFATF = 'No';
    if (ListB.includes(currentKycData?.details?.incorporationCountry)) {
      emptyFormData.countryCountermeasureFATF = 'Yes';
    }
    currentKycData?.details?.connectedParty.forEach(party => {
      if (ListB.includes(party.addressCountry) || ListB.includes(party.nationality)) {
        emptyFormData.countryCountermeasureFATF = 'Yes';
      }
    });

    // qn9
    emptyFormData.countryInadequateAML_CFT = 'No';
    if (ListC.includes(currentKycData?.details?.incorporationCountry)) {
      emptyFormData.countryInadequateAML_CFT = 'Yes';
    }
    currentKycData?.details?.connectedParty.forEach(party => {
      if (ListC.includes(party.addressCountry) || ListC.includes(party.nationality)) {
        emptyFormData.countryInadequateAML_CFT = 'Yes';
      }
    });

    // qn 18 // natureOfBusiness dropDown of industry
    emptyFormData.higherRiskSector = 'No';
    if (currentKycData?.details?.natureOfBusiness?.split(' - ')[0].includes('High')) {
      // ?.split() apparantly can use it to stop methods too, not just properties
      emptyFormData.higherRiskSector = 'Yes';
    }

    // q22
    emptyFormData.highRiskJurisdictionFATF = 'No';
    if (highRiskJurisdictions.includes(currentKycData?.details?.incorporationCountry)) {
      emptyFormData.highRiskJurisdictionFATF = 'Yes';
    }
    currentKycData?.details?.connectedParty.forEach(party => {
      if (highRiskJurisdictions.includes(party.addressCountry) || highRiskJurisdictions.includes(party.nationality)) {
        emptyFormData.highRiskJurisdictionFATF = 'Yes';
      }
    });

    // q23
    emptyFormData.credibleBodyIdentifiedCountry = 'No';
    if (transparencyInternational.includes(currentKycData?.details?.incorporationCountry)) {
      emptyFormData.credibleBodyIdentifiedCountry = 'Yes';
    }
    currentKycData?.details?.connectedParty.forEach(party => {
      if (
        transparencyInternational.includes(party.addressCountry) ||
        transparencyInternational.includes(party.nationality)
      ) {
        emptyFormData.credibleBodyIdentifiedCountry = 'Yes';
      }
    });

    return emptyFormData;
  }
}
